import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=251867c0&"
import script from "./EditCategory.vue?vue&type=script&lang=ts&"
export * from "./EditCategory.vue?vue&type=script&lang=ts&"
import style0 from "./EditCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditCategory.vue"
export default component.exports